import { render, staticRenderFns } from "./akcd_addAkcc.vue?vue&type=template&id=1389021c"
import script from "./akcd_addAkcc.vue?vue&type=script&lang=js"
export * from "./akcd_addAkcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports